import * as components from "flowbite-vue";

/**
 * Automatically register all components from flowbite-vue
 */
export default defineNuxtPlugin({
  enforce: "post", // Run this plugin after all other plugins

  setup(nuxtApp) {
    for (const [key, component] of Object.entries(components)) {
      nuxtApp.vueApp.component(key, component);
    }
  },
});
